import axios, { AxiosRequestConfig, AxiosResponse, Method } from "axios";

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const MAX_RETRIES = 3;
const BASE_DELAY_MS = 2000;

const customFetch = async <T>(
  url: string,
  method: Method,
  token?: string,
  data?: string
): Promise<AxiosResponse<T>> => {
  let headers: AxiosRequestConfig["headers"] = {
    "Content-Type": "application/json",
  };

  if (token !== undefined && token !== null && token !== "")
    headers.Authorization = `Token ${token}`;

  let lastError: any;

  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    try {
      const res = await axios({
        url,
        method,
        headers: headers,
        data: data,
      });
      console.info(res.status);
      console.log(res.headers);
      return res;
    } catch (error: any) {
      lastError = error;
      const status = error?.response?.status;

      // Retry on 429 (rate limited) or 503 (service unavailable)
      if ((status === 429 || status === 503) && attempt < MAX_RETRIES) {
        // Use Retry-After header if available, otherwise exponential backoff
        const retryAfter = error?.response?.headers?.["retry-after"];
        const delay = retryAfter
          ? parseInt(retryAfter, 10) * 1000
          : BASE_DELAY_MS * Math.pow(2, attempt);
        console.warn(
          `Got ${status} from ${url}, retrying in ${delay}ms (attempt ${attempt + 1}/${MAX_RETRIES})`
        );
        await sleep(delay);
        continue;
      }

      // Don't retry other errors
      throw error;
    }
  }

  // If all retries exhausted, throw the last error
  throw lastError;
};

export default customFetch;
